import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AuthShell from '../comps/authShell'
import { InputErrorMassage } from '../comps/comps'
import * as actions from '../store/authAction'
import { uploadPostFile } from '../utils/postImages'
import { clearSignupDraft, getSignupDraft, markNeedsPayment, setSignupDraft } from '../utils/signupDraft'
import { detectCountry } from '../utils/countries'

const AuthPhoto = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [file, setFile] = useState(null)
  const [preview, setPreview] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    const draft = getSignupDraft()
    if (!draft.email || !draft.password || !draft.name || !draft.bio) navigate('/auth', { replace: true })
  }, [navigate])

  useEffect(() => {
    if (!file) {
      setPreview('')
      return undefined
    }
    const url = URL.createObjectURL(file)
    setPreview(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  const pickPhoto = event => {
    const next = event.target.files && event.target.files[0]
    if (next && String(next.type || '').startsWith('image/')) setFile(next)
    event.target.value = ''
  }

  const finish = async (skipPhoto) => {
    const draft = getSignupDraft()
    if (!draft.email || !draft.password || !draft.name || !draft.bio) {
      navigate('/auth', { replace: true })
      return
    }
    setSaving(true)
    setError('')
    try {
      let imgName = ''
      if (file && !skipPhoto) {
        imgName = await uploadPostFile(file, 0)
      }
      let country = draft.country
      if (!country) {
        country = await detectCountry()
        if (country) setSignupDraft({ country })
      }
      try {
        await dispatch(actions.complete_signup(draft.email, draft.password, draft.name, imgName, draft.bio, country))
      } catch (err) {
        const text = String((err && err.message) || err || '')
        if (/taken|DUP|duplicate/i.test(text)) {
          await dispatch(actions.log_in(draft.email, draft.password))
        } else {
          throw (err instanceof Error ? err : new Error(text || 'Could not create account'))
        }
      }
      markNeedsPayment()
      clearSignupDraft()
      navigate('/payment', { replace: true })
    } catch (err) {
      const text = String((err && err.message) || err || '')
      setError(/taken/i.test(text) ? 'email is taken' : (text || 'Could not create account'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <AuthShell title="Profile photo">
      <p className="authStepLabel">Add a profile photo</p>
      <label className="authPhotoPick">
        {preview ? <img src={preview} alt="" /> : <span>Choose photo</span>}
        <input type="file" accept="image/*" onChange={pickPhoto} />
      </label>
      {error && <InputErrorMassage val={'hi'} num={[10, 10]} text={error} />}
      <button type="button" className="googlebuttons" onClick={() => finish(false)} disabled={saving}>
        {saving ? 'Creating…' : 'Create account'}
      </button>
      <p className="googlebuttonss" onClick={() => { if (!saving) finish(true); }}>{saving ? 'Creating…' : 'Skip'}</p>
      <p className="googlebuttonss" onClick={() => navigate('/auth/setup/bio')}>Back</p>
    </AuthShell>
  )
}

export default AuthPhoto
